import { Settings } from '@models/settings';

const ACTION_SCOPE = '[DOE settings]';

export class LoadSettings {
  static readonly type = `${ACTION_SCOPE} Load settings`;
}

export class UpdateSettings {
  static readonly type = `${ACTION_SCOPE} Update settings`;
  constructor(public settings: Settings) {}
}

export class UpdateSpecificTestSetting {
  static readonly type = `${ACTION_SCOPE} Update specific test setting`;
  constructor(
    public businessKey: string,
    public propertyName: string,
    public newVal: string,
  ) {}
}
